// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

export const mode = process.env.REACT_APP_BACKEND_MODE;
export const folderName = process.env.REACT_APP_FOLDER_NAME;
export const folderPusatName = process.env.REACT_APP_FOLDER_PUSAT_NAME;

const ROOTS_AUTH = mode === 'LOCAL' ? '/auth' : `/${folderName}/auth`;
const ROOTS_DASHBOARD =
  mode === 'LOCAL' ? '/dashboard' : `/${folderName}/dashboard`;

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  page404: '/404',
  page500: '/500',
};

export const PATH_HOME = {
  cloud: 'https://www.sketch.com/s/0fa4699d-a3ff-4cd5-a3a7-d851eb7e17f0',
  purchase: 'https://material-ui.com/store/items/minimal-dashboard/',
  components: '/components',
  dashboard: ROOTS_DASHBOARD,
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  component: {
    root: path(ROOTS_DASHBOARD, '/components'),
    accordion: path(ROOTS_DASHBOARD, '/components/accordion'),
    alert: path(ROOTS_DASHBOARD, '/components/alert'),
    autocomplete: path(ROOTS_DASHBOARD, '/components/autocomplete'),
  },
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/card'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
  profile: path(ROOTS_DASHBOARD, '/profile'),
  beranda: path(ROOTS_DASHBOARD, '/home'),

  //Administrasi Guru
  kikdSatuDua: path(ROOTS_DASHBOARD, '/kikd/satu-dua'),
  kikdTigaEmpat: path(ROOTS_DASHBOARD, '/kikd/tiga-empat'),
  prosem: path(ROOTS_DASHBOARD, '/program-semester'),
  prota: path(ROOTS_DASHBOARD, '/program-tahunan'),
  silabus: path(ROOTS_DASHBOARD, '/silabus'),
  rpp: path(ROOTS_DASHBOARD, '/rpp'),
  sumatif: path(ROOTS_DASHBOARD, '/sumatif'),
  rbm: path(ROOTS_DASHBOARD, '/rencana-bulanan-dan-mingguan'),
  alokasiWalikelas: path(ROOTS_DASHBOARD, '/alokasi-walikelas'),
  kepala_sekolah: path(ROOTS_DASHBOARD, '/kepala-sekolah'),

  //Master
  mapel: path(ROOTS_DASHBOARD, '/mapels'),
  penjadwalan: path(ROOTS_DASHBOARD, '/penjadwalan'),
  bahasa: path(ROOTS_DASHBOARD, '/bahasa'),
  matapelajaran: path(ROOTS_DASHBOARD, '/mata-pelajaran'),
  matapelajaranpilihan: path(ROOTS_DASHBOARD, '/mata-pelajaran-pilihan'),
  matapelajaranekskur: path(ROOTS_DASHBOARD, '/mata-pelajaran-ekskur'),
  matapelajarangabungan: path(ROOTS_DASHBOARD, '/mata-pelajaran-gabungan'),
  jurusan: path(ROOTS_DASHBOARD, '/jurusan'),
  kelas: path(ROOTS_DASHBOARD, '/kelas'),
  paralel: path(ROOTS_DASHBOARD, '/parallel'),
  settingJadwalInput: path(ROOTS_DASHBOARD, '/jadwal-input'),
  settingJadwalInputKategori: path(ROOTS_DASHBOARD, '/jadwal-input-category'),
  tahun_pelajaran: path(ROOTS_DASHBOARD, '/tahun-pelajaran'),
  profile_sekolah: path(ROOTS_DASHBOARD, '/profile-sekolah'),

  //Ekskur
  ekskul: path(ROOTS_DASHBOARD, '/ekskul'),
  ekskul_category: path(ROOTS_DASHBOARD, '/ekskul_category'),
  ekskul_student: path(ROOTS_DASHBOARD, '/ekskul_student'),
  ekskul_note: path(ROOTS_DASHBOARD, '/ekskul_note'),
  ekskulKelas: path(ROOTS_DASHBOARD, '/ekskul-kelas'),
  ekskul_presence: path(ROOTS_DASHBOARD, '/ekskul-presence'),

  //agenda guru
  agendaGuru: path(ROOTS_DASHBOARD, '/agenda-guru'),
  jurnalKelas: path(ROOTS_DASHBOARD, '/jurnal-kelas'),
  //Struktur Kurikulum
  alokasiwaktu: path(ROOTS_DASHBOARD, '/alokasi-waktu'),
  alokasi_waktu: {
    formDetail: path(ROOTS_DASHBOARD, '/alokasiwaktu/AlokasiWaktuDetail'),
    formDetail: path(ROOTS_DASHBOARD, '/alokasi-waktu/AlokasiWaktuDetail'),
  },
  laporan_alokasi_waktu: path(ROOTS_DASHBOARD, '/laporan_alokasi_waktu'),
  pembagiantugas: path(ROOTS_DASHBOARD, '/pembagian-tugas'),
  pembagian_tugas: {
    formDetail: path(ROOTS_DASHBOARD, '/pembagian-tugas/Pembagian-TugasDetail'),
    bykelas: path(ROOTS_DASHBOARD, '/pembagian-tugas-perkelas'),
  },
  pembagiantugasnew: path(ROOTS_DASHBOARD, '/pembagian-tugas-new'),
  jadwalpelajaran: path(ROOTS_DASHBOARD, '/laporan_jadwal_pelajaran'),
  jadwalPelajaranUpload: path(ROOTS_DASHBOARD, '/jadwal-pelajaran-upload'),

  //Pengaturan Siswa
  laporan_pembagian_tugas: path(ROOTS_DASHBOARD, '/laporan_pembagian_tugas'),
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  laporan_kegiatan: path(ROOTS_DASHBOARD, '/laporan_kegiatan'),
  pengaturan_siswa: path(ROOTS_DASHBOARD, '/pengaturan-siswa'),
  pengaturan_siswa_edit: path(
    ROOTS_DASHBOARD,
    '/pengaturan-siswa/student/:niy',
  ),
  pengaturan_buku_panduan: path(ROOTS_DASHBOARD, '/buku-panduan-siswa'),

  pengaturan_buku_induk: path(ROOTS_DASHBOARD, '/pengaturan-buku-induk'),
  edit_buku_induk: path(
    ROOTS_DASHBOARD,
    '/pengaturan-buku-induk/buku-induk/:id',
  ),

  jampelajaran: path(ROOTS_DASHBOARD, '/jampelajaran'),
  jadwalguru: path(ROOTS_DASHBOARD, '/jadwalguru'),
  jadwal_guru: {
    formDetail: path(ROOTS_DASHBOARD, '/jadwalguru/Jadwal-GuruDetail'),
  },

  //Intrakurikuler
  intrakurikuler: {
    master: path(ROOTS_DASHBOARD, '/master-intrakurikuler'),
    ruang_lingkup_materi: path(ROOTS_DASHBOARD, '/ruang-lingkup-materi'),
    tujuan_pembelajaran: path(ROOTS_DASHBOARD, '/tujuan-pembelajaran'),
    aspect_indicator: path(ROOTS_DASHBOARD, '/aspek_indikator'),
    upload_materi: path(ROOTS_DASHBOARD, '/upload-materi'),
    upload_tugas: path(ROOTS_DASHBOARD, '/upload-tugas'),
    upload_materi_tk: path(ROOTS_DASHBOARD, '/upload-materi-tk'),
    student_excercise: path(ROOTS_DASHBOARD, '/student-excercise'),
  },
  term: path(ROOTS_DASHBOARD, '/term'),
  assesment_category: path(ROOTS_DASHBOARD, '/assesment_category'),
  chinese_name_setting: path(ROOTS_DASHBOARD, '/chinese_name_setting'),
  assesment: {
    list: path(ROOTS_DASHBOARD, '/assesment_term'),
    form: path(ROOTS_DASHBOARD, '/assesment_term/form'),
  },
  mapel_siswa: path(ROOTS_DASHBOARD, '/mapel-siswa'),

  //Penilaian
  penilaian: {
    formatif: path(ROOTS_DASHBOARD, '/penilaian-formatif'),
    sumatif: path(ROOTS_DASHBOARD, '/penilaian-sumatif'),
    sumatif_akhir: path(ROOTS_DASHBOARD, '/penilaian-sumatif-akhir'),
    ekskul: path(ROOTS_DASHBOARD, '/penilaian-ekskul'),
    akhir: path(ROOTS_DASHBOARD, '/penilaian-akhir'),
    nus: path(ROOTS_DASHBOARD, '/penilaian-nus'),
  },
  //Laporan
  laporan: {
    formatif: path(ROOTS_DASHBOARD, '/laporan-nilai-formatif'),
    sumatif: path(ROOTS_DASHBOARD, '/laporan-nilai-sumatif'),
    ekskul: path(ROOTS_DASHBOARD, '/laporan-nilai-ekskul'),
    sumatif_as: path(ROOTS_DASHBOARD, '/laporan-nilai-sumatif-as'),
  },
  //Rapor
  report: {
    weekly_for_teacher: path(
      ROOTS_DASHBOARD,
      '/weekly_appraisal_report/teacher',
    ),
    weekly_for_parent: path(ROOTS_DASHBOARD, '/weekly_appraisal_report/parent'),
  },
  rapor: {
    general_ledger_real: path(ROOTS_DASHBOARD, '/general-ledger-real'),
    general_ledger: path(ROOTS_DASHBOARD, '/general-ledger'),
    generate_sumatif_formatif: path(
      ROOTS_DASHBOARD,
      '/generate-rapor-sumatif-formatif',
    ),
    sumatif_formatif: path(ROOTS_DASHBOARD, '/rapor-sumatif-formatif'),
    urutan_rapor: path(ROOTS_DASHBOARD, '/urutan-rapor'),
    setting_tanggal: path(ROOTS_DASHBOARD, '/setting-tanggal-rapor'),
    mid_semester: path(ROOTS_DASHBOARD, '/rapor-mid-semester'),
    rapor_proyek: path(ROOTS_DASHBOARD, '/rapor_proyek'),
    setting_penilaian_rapor: path(ROOTS_DASHBOARD, '/setting-penilaian-rapor'),
    setting_persentase_kelulusan: path(
      ROOTS_DASHBOARD,
      '/setting-persentase-kelulusan',
    ),
    rapor_tk: path(ROOTS_DASHBOARD, '/rapor-tk'),
    rapor_tk_wakil: path(ROOTS_DASHBOARD, '/rapor-tk-wakil'),
    setting: path(ROOTS_DASHBOARD, '/setting-rapor'),
    generate_nilai_kelulusan: path(
      ROOTS_DASHBOARD,
      '/generate-nilai-kelulusan',
    ),
    general_ledger_kelulusan: path(
      ROOTS_DASHBOARD,
      '/general-ledger-kelulusan',
    ),
  },

  cover: {
    coverraport: path(ROOTS_DASHBOARD, '/cover-raport'),
  },
  catatan_walikelas: path(ROOTS_DASHBOARD, '/catatan-walikelas'),
  catatan_walikelas_tk: path(ROOTS_DASHBOARD, '/catatan-walikelas-tk'),
  prestasi_siswa: path(ROOTS_DASHBOARD, '/prestasi-siswa'),

  //P5
  fase: path(ROOTS_DASHBOARD, '/fase'),
  dimensi: path(ROOTS_DASHBOARD, '/dimensi'),
  fase: path(ROOTS_DASHBOARD, '/fase'),
  alokasiWalikelas: path(ROOTS_DASHBOARD, '/alokasi-walikelas'),
  absensiSiswa: path(ROOTS_DASHBOARD, '/absensi-siswa'),
  settingJadwalInput: path(ROOTS_DASHBOARD, '/jadwal-input'),
  settingJadwalInputKategori: path(ROOTS_DASHBOARD, '/jadwal-input-category'),
  tujuanPembelajaran: path(ROOTS_DASHBOARD, '/tujuan-pembelajaran'),
  dimensi: path(ROOTS_DASHBOARD, '/dimensi'),
  tahun_pelajaran: path(ROOTS_DASHBOARD, '/tahun-pelajaran'),
  profile_sekolah: path(ROOTS_DASHBOARD, '/profile-sekolah'),
  kepala_sekolah: path(ROOTS_DASHBOARD, '/kepala-sekolah'),
  alokasiGuruP5: path(ROOTS_DASHBOARD, '/alokasi-gurup5'),
  catatan_proses: path(ROOTS_DASHBOARD, '/catatan_proses'),
  template_catatan_proses: path(ROOTS_DASHBOARD, '/template_catatan_proses'),
  penilaian_proyek: path(ROOTS_DASHBOARD, '/penilaian_proyek'),
  proyek: path(ROOTS_DASHBOARD, '/proyek'),
  proyek_detail: {
    formDetail: path(ROOTS_DASHBOARD, '/proyek/ProyekDetail'),
  },

  //Mapel Pilihan Wajib
  mapelpilihanwajib: {
    // mapellist: path(ROOTS_DASHBOARD, "/mapel-pilihan-wajib"),
    tahunpelajaran: path(ROOTS_DASHBOARD, '/tahun-pelajaran'),
    jenjang: path(ROOTS_DASHBOARD, '/jenjang/option'),
    mapelpilihanwajib: path(ROOTS_DASHBOARD, '/mapel-pilihan-wajib'),
    daftarmapelpilihanwajib: path(
      ROOTS_DASHBOARD,
      '/daftar-mapel-pilihan-wajib',
    ),
    pelajaran: path(ROOTS_DASHBOARD, '/mata-pelajaran'),
    kelaspilih: path(ROOTS_DASHBOARD, '/kelas-pilih'),
    storekuotamapelwajib: path(ROOTS_DASHBOARD, '/mapil-wajib-simpan'),
    updatekuotamapelwajib: path(ROOTS_DASHBOARD, '/mapil-wajib-update'),
  },
  mapil_siswa: path(ROOTS_DASHBOARD, '/mapil-siswa'),
  mapil_kelas: path(ROOTS_DASHBOARD, '/mapil-kelas'),
  siswa_non_aktif: path(ROOTS_DASHBOARD, '/siswa-nonaktif'),
  siswa_mutasi_manual: path(ROOTS_DASHBOARD, '/siswa-mutasi-manual'),
  pengajar_ekskul: path(ROOTS_DASHBOARD, '/pengajar-ekskul'),
  //approval mapel pilihan wajib
  mapelpilihanwajibapproval: path(
    ROOTS_DASHBOARD,
    '/mata-pelajaran-pilihan-approval',
  ),
  information: path(ROOTS_DASHBOARD, '/information'),
  gallery: path(ROOTS_DASHBOARD, '/gallery'),
  tugas_tambahan: path(ROOTS_DASHBOARD, '/tugas-tambahan'),
  notulen: {
    rapat_rumpun: path(ROOTS_DASHBOARD, '/rapat-rumpun'),
  },
  alokasi_kesenian: path(ROOTS_DASHBOARD, '/alokasi-kesenian'),
  alokasi_keterampilan: path(ROOTS_DASHBOARD, '/alokasi-keterampilan'),
  setting_buka_tutup: path(ROOTS_DASHBOARD, '/setting-buka-tutup'),
  students: path(ROOTS_DASHBOARD, '/students'),
  studentList: path(ROOTS_DASHBOARD, '/list-siswa'),
  catatan_kesiswaan: path(ROOTS_DASHBOARD, '/catatan-kesiswaan'),
  jadwal_ulangan: path(ROOTS_DASHBOARD, '/jadwal-ulangan'),
  jadwal_ulangan_sumatif: path(ROOTS_DASHBOARD, '/jadwal-ulangan-sumatif'),
  jadwal_ulangan_pas: path(ROOTS_DASHBOARD, '/jadwal-ulangan-pas'),
  rombel: path(ROOTS_DASHBOARD, '/rombel'),
  upload_nilai_rapor_5: path(ROOTS_DASHBOARD, '/upload-nilai-rapor-5'),
};
